import { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { Context } from "../../components/Context";
import { useNavigate, useParams } from "../../../node_modules/react-router-dom/dist/index";
import { useForm } from "react-hook-form";
import { Editor } from "@tinymce/tinymce-react";
import { CREATE_CARPOOL, GET_ALL_STATE_BY_COUNTY_ID, GET_CITY_STATE_AND_COUNTRY_ID, fetchData } from "../../components/Service";
import DatePicker from "react-date-picker";
import moment from "../../../node_modules/moment/moment";
import Select from "react-select";
import { PhoneNumberUtil } from "google-libphonenumber";
import { PhoneInput, defaultCountries, parseCountry } from "react-international-phone";
import "react-international-phone/style.css";

const phoneUtil = PhoneNumberUtil.getInstance();

const CreateCarpool = () => {
	const { carpool_id } = useParams();
	const navigate = useNavigate();
	const [context] = useContext(Context);
	const [fromStateList, setFromStateList] = useState([]);
	const [fromCityList, setFromCityList] = useState([]);
	const [toStateList, setToStateList] = useState([]);
	const [toCityList, setToCityList] = useState([]);
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const [selFromSt, setSelFromSt] = useState(null);
	const [selFromCt, setSelFromCt] = useState(null);
	const [selToSt, setSelToSt] = useState(null);
	const [selToCt, setSelToCt] = useState(null);

	const [defaultPhoneCountry] = useState("us");
	const [fullPhone, setFullPhone] = useState("");

	const countriesList = context?.countryList?.map((item) => item?.code?.toLowerCase()) || [];

	const countries = defaultCountries.filter((country) => {
		const { iso2 } = parseCountry(country);
		return countriesList.includes(iso2);
	});

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		setValue,
		setError,
		clearErrors,
		reset,
		trigger,
		getValues,
	} = useForm({ mode: "onChange" });

	const isPhoneValid = (phone, country_code) => {
		try {
			// if (!phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone))) {
			// 	setError("contact_number", { message: "Mobile number is invalid." });
			// 	setValue("contact_number", "");
			// } else {
			// 	clearErrors("contact_number");
			// 	setValue("contact_number", phone);
			// }

			const onlyPhone = phone.replace(`+${country_code}`, "").trim();
			if (onlyPhone) {
				setValue("contact_number", phone, { shouldValidate: true });
				clearErrors("contact_number");
			} else {
				setValue("contact_number", "");
				// setError("contact_number", { message: "Mobile number is required." });
			}
		} catch (error) {
			return false;
		}
	};

	const getAllStateByCountryId = (country_id, type) => {
		let value = {
			country_id: country_id,
		};

		fetchData(GET_ALL_STATE_BY_COUNTY_ID, "POST", value, false, false, (res) => {
			if (res.status) {
				if (type === "from") {
					setFromStateList(res?.data);
				} else {
					setToStateList(res?.data);
				}
			} else {
				if (type === "from") {
					setFromStateList([]);
				} else {
					setToStateList([]);
				}
			}
		});
	};

	const getAllCityByStateAndCountryId = (state_id, type) => {
		let value = {
			country_id: type === "from" ? getValues("from_country_id") : getValues("to_country_id"),
			state_id: state_id,
		};

		fetchData(GET_CITY_STATE_AND_COUNTRY_ID, "POST", value, false, false, (res) => {
			if (res.status) {
				if (type === "from") {
					setFromCityList(res?.data);
				} else {
					setToCityList(res?.data);
				}
			} else {
				if (type === "from") {
					setFromCityList([]);
				} else {
					setToCityList([]);
				}
			}
		});
	};

	const createData = (data) => {
		data = {
			user_id: context?.user?.user_id,
			country_id: context?.countryId,
			state_id: context?.stateId,
			category_id: carpool_id,
			...data,
			start_date: data?.start_date? moment(data?.start_date).format("YYYY-MM-DD"):null,
			end_date:data?.end_date? moment(data?.end_date).format("YYYY-MM-DD"): null,
		};

		fetchData(CREATE_CARPOOL, "POST", data, true, false, (res) => {
			if (res.status) {
				toast.success("Carpool created successfully.");
				navigate(`/profile?tab=ads`);
				// navigate(`/carpool/${carpool_id}`, { state: { pageTitle: carpool_id == 1 ? "Local" : carpool_id == 2 ? "Interstate" : "International" } });
			} else {
				toast.error(res.message);
			}
		});
	};

	useEffect(() => {
		if (carpool_id == 2 && context?.countryId) {
			setValue("from_country_id", context?.countryId);
			setValue("to_country_id", context?.countryId);
			getAllStateByCountryId(context?.countryId, "from");
			getAllStateByCountryId(context?.countryId, "to");
		}

		if (carpool_id == 1 && context?.countryId && context?.stateId) {
			setValue("from_country_id", context?.countryId);
			setValue("to_country_id", context?.countryId);
			setValue("from_state_id", context?.stateId);
			setValue("to_state_id", context?.stateId);
			getAllCityByStateAndCountryId(context?.stateId, "from");
			getAllCityByStateAndCountryId(context?.stateId, "to");
		}
	}, [carpool_id, context?.stateId]);

	useEffect(() => {
		setValue("contact_email", context?.user?.email ?? "");
		setValue("contact_address", context?.user?.address ?? "");
		setValue("contact_name", context?.user?.name ?? "");
		setValue("contact_number", context?.user?.mobile ?? "");
		setFullPhone(context?.user?.mobile ?? "");
	}, [context?.user]);

	return (
		<>
			{context?.userToken ? (
				<div class="col-lg-12">
					<div class="card card-forum ">
						<div class="card-header usa-bg px-1">
							<div className="national-bg">
								<h4 class="text-white py-1 ind1">Create {carpool_id == 1 ? "Local" : carpool_id == 2 ? "Interstate" : "International"} Carpool</h4>
							</div>
						</div>

						<div class="card-body bg-white px-1">
							<form className="needs-validation" onSubmit={handleSubmit(createData)}>
								<div className="row">
									<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
										<label>
											Category <span className="text-danger">*</span>
										</label>
										<input
											className={`form-control bg-transparent`}
											placeholder="Category"
											value={carpool_id == 1 ? "Local" : carpool_id == 2 ? "Interstate" : "International"}
											disabled
										/>
									</div>
									<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
										<label>
											Name
											<span className="text-danger">*</span>
										</label>
										<input
											className={`form-control bg-transparent ${errors.contact_name && "is-invalid"}`}
											placeholder="Name"
											maxLength={50}
											{...register("contact_name", {
												required: { value: true, message: "Name is required." },
												pattern: {
													value: /^[A-Za-z ]+$/,
													message: "Only alphabetic characters are allowed.",
												},
											})}
											readOnly 
										/>
										{errors.contact_name && <div class="invalid-feedback">{errors.contact_name.message}</div>}
									</div>
									<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
										<label>
											Email
											<span className="text-danger">*</span>
										</label>
										<input
											className={`form-control bg-transparent ${errors.contact_email && "is-invalid"}`}
											placeholder="Email"
											type="contact_email"
											maxLength={120}
											{...register("contact_email", {
												required: { value: true, message: "Email is required." },
												pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, message: "Email is invalid." },
											})}
											readOnly 
										/>
										{errors.contact_email && <div class="invalid-feedback">{errors.contact_email.message}</div>}
									</div>
									<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
										<label>
											Mobile Number
											{/* <span className="text-danger">*</span> */}
										</label>

										<PhoneInput
											key={defaultPhoneCountry}
											defaultCountry={defaultPhoneCountry}
											countries={countries}
											forceDialCode={true}
											value={fullPhone}
											hideDropdown={false}
											disableCountryGuess={true}
											onChange={(phone, country) => {
												isPhoneValid(phone, country.country.dialCode);
												setFullPhone(phone);
											}}
											className={`form-control bg-transparent p-0 ${errors.contact_number ? "is-invalid" : ""}`}
										/>
										<input
											type="hidden"
											{...register("contact_number", {
												// required: "Mobile number is required.",
											})}
										/>
										{errors.contact_number && <div class="invalid-feedback">{errors.contact_number.message}</div>}
									</div>
									<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
										<label>
											Journey type
											{/* <span className="text-danger">*</span> */}
										</label>

										<Select
											{...register("journey_type", {
												// required: { value: true, message: "Select an journey type." },
											})}
											options={[
												{ label: "One Way", value: "oneway" },
												{ label: "Two Way", value: "twoway" },
											]}
											onChange={(selected) => {
												setValue("journey_type", selected ? selected.value : "");
												trigger("journey_type");
											}}
											placeholder="Select an journey type"
											className={`selectpicker p-0 ${errors.journey_type && "is-invalid bdr-red"}`}
											classNamePrefix="react-select"
										/>
										{errors.journey_type && <div class="invalid-feedback d-block">{errors.journey_type.message}</div>}
									</div>
									{carpool_id == 3 && (
										<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
											<label>
												From Country
												{/* <span className="text-danger">*</span> */}
											</label>

											<Select
												{...register("from_country_id", {
													// required: { value: true, message: "Select a country." },
												})}
												options={context?.countryList?.map((item) => ({
													label: item.name,
													value: item.id,
												}))}
												onChange={(selected) => {
													getAllStateByCountryId(selected ? selected.value : "", "from");
													setValue("from_country_id", selected ? selected.value : "");
													trigger("from_country_id");

													setSelFromSt(null);
													setSelFromCt(null);
													setValue("from_state_id", "");
													trigger("from_state_id");

													setValue("from_city_id", "");
													trigger("from_city_id");
												}}
												placeholder="Select a country"
												className={`selectpicker p-0 ${errors.from_country_id && "is-invalid bdr-red"}`}
												classNamePrefix="react-select"
												isSearchable={false}
											/>
											{errors.from_country_id && <div class="invalid-feedback d-block">{errors.from_country_id.message}</div>}
										</div>
									)}

									{carpool_id != 1 && (
										<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
											<label>
												From State
												{/* <span className="text-danger">*</span> */}
											</label>

											<Select
												{...register("from_state_id", {
													// required: { value: true, message: "Select a state." },
												})}
												options={fromStateList?.map((item) => ({
													label: item.name,
													value: item.id,
												}))}
												value={selFromSt}
												onChange={(selected) => {
													getAllCityByStateAndCountryId(selected ? selected.value : "", "from");
													setValue("from_state_id", selected ? selected.value : "");
													trigger("from_state_id");

													setSelFromSt(selected);
													setSelFromCt(null);

													setValue("from_city_id", "");
													trigger("from_city_id");
												}}
												placeholder="Select a state"
												className={`selectpicker p-0 ${errors.from_state_id && "is-invalid bdr-red"}`}
												classNamePrefix="react-select"
											/>
											{errors.from_state_id && <div class="invalid-feedback d-block">{errors.from_state_id.message}</div>}
										</div>
									)}

									<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
										<label>
											From City
											{/* <span className="text-danger">*</span> */}
										</label>

										<Select
											{...register("from_city_id", {
												// required: { value: true, message: "Select a city." },
											})}
											options={fromCityList?.map((item) => ({
												label: item.name,
												value: item.id,
											}))}
											value={selFromCt}
											onChange={(selected) => {
												setSelFromCt(selected);
												setValue("from_city_id", selected ? selected.value : "");
												trigger("from_city_id");
											}}
											placeholder="Select a city"
											className={`selectpicker p-0 ${errors.from_city_id && "is-invalid bdr-red"}`}
											classNamePrefix="react-select"
										/>
										{errors.from_city_id && <div class="invalid-feedback d-block">{errors.from_city_id.message}</div>}
									</div>
									<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
										<label>
											Address
											{/* <span className="text-danger">*</span> */}
										</label>
										<input
											class={`form-control ${errors.contact_address && "is-invalid"}`}
											rows="5"
											placeholder="Address"
											{...register("contact_address", {
												// required: { value: true, message: "Address is required." },
											})}
										></input>
										{errors.contact_address && <div class="invalid-feedback d-block">{errors.contact_address.message}</div>}
									</div>
									{carpool_id == 3 && (
										<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
											<label>
												To Country
												{/* <span className="text-danger">*</span> */}
											</label>

											<Select
												{...register("to_country_id", {
													// required: { value: true, message: "Select a country." },
												})}
												options={context?.countryList?.map((item) => ({
													label: item.name,
													value: item.id,
												}))}
												onChange={(selected) => {
													getAllStateByCountryId(selected ? selected.value : "", "to");
													setValue("to_country_id", selected ? selected.value : "");
													trigger("to_country_id");

													setSelToSt(null);
													setSelToCt(null);
													setValue("to_state_id", "");
													trigger("to_state_id");

													setValue("to_city_id", "");
													trigger("to_city_id");
												}}
												placeholder="Select a country"
												className={`selectpicker p-0 ${errors.to_country_id && "is-invalid bdr-red"}`}
												classNamePrefix="react-select"
												isSearchable={false}
											/>
											{errors.to_country_id && <div class="invalid-feedback d-block">{errors.to_country_id.message}</div>}
										</div>
									)}

									{carpool_id != 1 && (
										<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
											<label>
												To State
												{/* <span className="text-danger">*</span> */}
											</label>

											<Select
												{...register("to_state_id", {
													// required: { value: true, message: "Select a state." },
												})}
												options={toStateList?.map((item) => ({
													label: item.name,
													value: item.id,
												}))}
												value={selToSt}
												onChange={(selected) => {
													getAllCityByStateAndCountryId(selected ? selected.value : "", "to");
													setValue("to_state_id", selected ? selected.value : "");
													trigger("to_state_id");

													setSelToSt(selected);
													setSelToCt(null);

													setValue("to_city_id", "");
													trigger("to_city_id");
												}}
												placeholder="Select a state"
												className={`selectpicker p-0 ${errors.to_state_id && "is-invalid bdr-red"}`}
												classNamePrefix="react-select"
											/>
											{errors.to_state_id && <div class="invalid-feedback d-block">{errors.to_state_id.message}</div>}
										</div>
									)}

									<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
										<label>
											To City
											{/* <span className="text-danger">*</span> */}
										</label>

										<Select
											{...register("to_city_id", {
												// required: { value: true, message: "Select a city." },
											})}
											options={toCityList?.map((item) => ({
												label: item.name,
												value: item.id,
											}))}
											value={selToCt}
											onChange={(selected) => {
												setSelToCt(selected);
												setValue("to_city_id", selected ? selected.value : "");
												trigger("to_city_id");
											}}
											placeholder="Select a city"
											className={`selectpicker p-0 ${errors.to_city_id && "is-invalid bdr-red"}`}
											classNamePrefix="react-select"
										/>
										{errors.to_city_id && <div class="invalid-feedback d-block">{errors.to_city_id.message}</div>}
									</div>



									<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
										<label>
											Start Date
											{/* <span className="text-danger">*</span> */}
										</label>
										<div className="custom-datepicker-wrapper">
											<DatePicker
												className={`form-control bg-transparent dp ${errors.start_date && "is-invalid"}`}
												clearIcon={false}
												monthPlaceholder="MM"
												dayPlaceholder="DD"
												yearPlaceholder="YYYY"
												onChange={(date) => {
													setStartDate(date);
													setValue("start_date", date, { shouldValidate: true });
												}}
												minDate={new Date()}
												value={startDate}
											/>
										</div>
										<input
											type="hidden"
											{...register("start_date", {
												// required: "Start date is required.",
											})}
										/>
										{errors.start_date && <div class="invalid-feedback d-block">{errors.start_date.message}</div>}
									</div>

									<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
										<label>
											Start Time
											{/* <span className="text-danger">*</span> */}
										</label>
										<input
											className={`form-control bg-transparent ${errors.start_time && "is-invalid"}`}
											placeholder="mm/dd/yyyy"
											type="time"
											onKeyDown={(e) => e.preventDefault()}
											onClick={(e) => e.target.showPicker?.()}
											{...register("start_time", {
												// required: { value: true, message: "Start time is required." },
											})}
										/>
										{errors.start_time && <div class="invalid-feedback">{errors.start_time.message}</div>}
									</div>
									{watch("journey_type") === "twoway" ? <><div className="col-sm-6 col-md-4 col-lg-3 mb-2">
										<label>
											Return Date
											{/* <span className="text-danger">*</span> */}
										</label>
										<div className="custom-datepicker-wrapper">
											<DatePicker
												className={`form-control bg-transparent dp ${errors.end_date && "is-invalid"}`}
												clearIcon={false}
												monthPlaceholder="MM"
												dayPlaceholder="DD"
												yearPlaceholder="YYYY"
												onChange={(date) => {
													setEndDate(date);
													setValue("end_date", date, { shouldValidate: true });
												}}
												minDate={startDate ? new Date(startDate) : new Date()}
												value={endDate}
											/>
										</div>
										<input
											type="hidden"
											{...register("end_date", {
												// required: "End date is required.",
											})}
										/>
										{errors.end_date && <div class="invalid-feedback d-block">{errors.end_date.message}</div>}
									</div>

										<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
											<label>
												Return Time
												{/* <span className="text-danger">*</span> */}
											</label>
											<input
												className={`form-control bg-transparent ${errors.end_time && "is-invalid"}`}
												placeholder="mm/dd/yyyy"
												onKeyDown={(e) => e.preventDefault()}
												onClick={(e) => e.target.showPicker?.()}
												type="time"
												{...register("end_time", {
													// required: { value: true, message: "End time is required." },
												})}
											/>
											{errors.end_time && <div class="invalid-feedback">{errors.end_time.message}</div>}
										</div></> : <></>}


									<div className="col-sm-6 col-md-4 col-lg-3 mt-3">
										<label>
											Flex Date
											{/* <span className="text-danger">*</span> */}
										</label>
										<div>
											<div class="form-check form-check-inline">
												<input class="form-check-input" type="radio" id="flex_date_1" {...register("flex_date")} value="yes" />
												<label class="form-check-label" for="flex_date_1">
													Yes
												</label>
											</div>
											<div class="form-check form-check-inline">
												<input class="form-check-input" type="radio" id="flex_date_2" {...register("flex_date")} value="no" checked />
												<label class="form-check-label" for="flex_date_2">
													No
												</label>
											</div>
										</div>
									</div>

									<div className="col-sm-6 col-md-4 col-lg-3 mt-3">
										<label>
											Flex Time
											{/* <span className="text-danger">*</span> */}
										</label>
										<div>
											<div class="form-check form-check-inline">
												<input class="form-check-input" type="radio" id="flex_time_1" {...register("flex_time")} value="yes" />
												<label class="form-check-label" for="flex_time_1">
													Yes
												</label>
											</div>
											<div class="form-check form-check-inline">
												<input class="form-check-input" type="radio" id="flex_time_2" {...register("flex_time")} value="no" checked />
												<label class="form-check-label" for="flex_time_2">
													No
												</label>
											</div>
										</div>
									</div>

									<div className="col-sm-6 col-md-4 col-lg-3 mt-3">
										<label>
											Flex Location
											{/* <span className="text-danger">*</span> */}
										</label>
										<div>
											<div class="form-check form-check-inline">
												<input class="form-check-input" type="radio" id="flex_location_1" {...register("flex_location")} value="yes" />
												<label class="form-check-label" for="flex_location_1">
													Yes
												</label>
											</div>
											<div class="form-check form-check-inline">
												<input class="form-check-input" type="radio" id="flex_location_2" {...register("flex_location")} value="no" checked />
												<label class="form-check-label" for="flex_location_2">
													No
												</label>
											</div>
										</div>
									</div>

									<div className="col-12 mb-2">
										<label>
											Description <span className="text-danger">*</span>
										</label>
										<textarea
											class={`form-control ${errors.description && "is-invalid"}`}
											rows="5"
											placeholder="Description"
											{...register("description", {
												required: { value: true, message: "Description is required." },
											})}
										></textarea>
										{errors.description && <div class="invalid-feedback d-block">{errors.description.message}</div>}
									</div>
								</div>
								<div className="text-end mt-3">
									<button class="btn btn-warning font13 d-inline-flex align-items-center" type="submit">
										Save <i className="fi fi-rr-arrow-small-right ms-2"></i>
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			) : (
				<div class="col-lg-12">
					<div class="card card-forum ">
						<div class="card-body bg-white p-1">
							<div class="text-center text-danger p-3">Please <a href="#!" className=" fw-bold" data-bs-toggle="modal" data-bs-target="#loginModal">
								Login
							</a> to view details.</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default CreateCarpool;
